import { Flex } from '@joinrepublic/dls-ui-kit';

import { CategoryColumn } from './category-list';

export const DesktopCategoryLists = () => (
  <Flex gap="6" flexWrap="nowrap" justifyContent="space-between">
    <CategoryColumn
      heading="Invest"
      variant="light"
      items={[
        { label: 'Start investing', url: '/investment-opportunities' },
        { label: 'Accredited deals', url: '/ventures' },
        { label: 'Trade', url: '/trading' },
      ]}
    />
    <CategoryColumn
      heading="Raise"
      variant="mid"
      items={[
        { label: 'Raise capital', url: '/raise' },
        { label: 'Equity rewards', url: '/sharedrops' },
        { label: 'Launch a token', url: '/launchpad' },
      ]}
    />
    <CategoryColumn
      heading="Build"
      variant="light"
      items={[
        { label: 'RWA tokenization', url: '/tokenization' },
        { label: 'Blockchain infrastructure', url: '/infrastructure' },
        { label: 'Advisory and research', url: '/advisory' },
      ]}
    />
  </Flex>
);
